import type { TimeStreamProject } from 'owa-timestream-types';
import { OutlookCalendarAppName } from '../constants';
import getBoardProjects from './getBoardProjects';

/**
 * Gets the default board project. NOTE: we assume there is exactly one project tagged with Calendar
 * app name.
 * @returns the default board project.
 */
export default function getDefaultBoardProject(): TimeStreamProject | undefined {
    return getBoardProjects().filter(project => project.appName === OutlookCalendarAppName)[0];
}
